export default __webpack_public_path__ + "static/media/pos.d67b78e2.png";